<template>
  <div class="no-box-shadow-expand">
    <v-card flat>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="
            items.filter(x => x.est_intermediaire === true && x.quantity > 0)
          "
          :search="search"
          item-key="id"
          sort-by="name"
          :mobile-breakpoint="0"
          :items-per-page="items.length + 1"
          hide-default-footer
        >
          <template v-slot:item.quantity="{ item }">
            <span> {{ item.quantity }} </span>
            <span class="caption ml-1">{{ getProductUnit(item) }}</span>
          </template>
          <template v-slot:item.quantity_required_recipe="{ item }">
            <span> {{ getQuantityRequireByRecipe(item) }} </span>
            <span class="caption ml-1">{{ getProductUnit(item) }}</span>
          </template>
          <template v-slot:item.quantity_required="{ item }">
            <span class="font-weight-bold">
              {{ item.quantity_required }}
            </span>
            <span class="caption">{{ getProductUnit(item) }}</span>
          </template>
          <template v-slot:top>
            <v-row justify="end" class="mx-1 no-print" dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  hide-details
                  single-line
                  clearable
                  append-icon="fa-search"
                  :value="search"
                  @change="v => (search = v)"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card v-show="false">
      <v-card-text>
        <v-data-table
          :headers="primaryProductsHeaders"
          :items="items.filter(x => x.est_intermediaire === false)"
          item-key="id"
          sort-by="name"
        >
          <template v-slot:item.quantity_required="{ item }">
            <v-row align="center" justify="space-between" no-gutters>
              <span>
                {{ item.quantity + getQuantityRequireByRecipe(item) }}
              </span>
              <span class="caption">{{ getProductUnit(item) }}</span>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { round10 } from "round10";
import { mappers } from "@/mappers";
export default {
  name: "PreparationSlipTemplateViewerGrid",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getRecipes", "getProducts"])
  },
  data() {
    return {
      tags: [],
      tabs: 0,
      search: "",
      headers: [
        { value: "nom", text: "Produit" },
        { value: "quantity", text: "Quantité pour la journée" },
        {
          value: "quantity_required_recipe",
          text: "Quantité requise par d'autre production"
        },
        { value: "quantity_required", text: "Quantité à produire total" }
      ],
      primaryProductsHeaders: [
        { value: "nom", text: "Produit" },
        { value: "quantity_required", text: "Quantité à produire total" }
      ]
    };
  },
  methods: {
    getQuantityRequireByRecipe(item) {
      const productsWithQuantities = this.items.filter(
        x => x.est_intermediaire === true
      );
      let quantity_required_recipe = 0;
      productsWithQuantities.forEach(product => {
        const recipe = this.getRecipes.find(
          x => x.fk_produit_intermediaire === product.id
        );

        if (recipe) {
          const ingredients = this.$store.getters.getIngredientsByRecipe(
            recipe.id
          );
          const ingredient = ingredients.find(
            i => i.pk_recette_produit.id == item.id
          );
          if (ingredient) {
            let ingredient_quantity = ingredient.quantite;
            const ingredientProduct = this.getProducts.find(
              p => p.id === ingredient.pk_recette_produit.id
            );
            if (ingredientProduct.data.use_conversion_formula) {
              if (
                !mappers.isCustomUnit(ingredient.unite_mesure) &&
                !mappers.isCustomUnit(ingredientProduct.data.unite_mesure)
              ) {
                ingredient_quantity = this.$units(ingredient.quantite)
                  .from(ingredient.unite_mesure)
                  .to(ingredientProduct.data.unite_mesure);
              }
            } else {
              if (
                !mappers.isCustomUnit(ingredient.unite_mesure) &&
                !mappers.isCustomUnit(
                  ingredientProduct.data.unite_mesure_inventory
                )
              ) {
                ingredient_quantity = this.$units(ingredient.quantite)
                  .from(ingredient.unite_mesure)
                  .to(ingredientProduct.data.unite_mesure_inventory);
              }
            }
            if (ingredientProduct.est_intermediaire) {
              const ingredientRecipe = this.getRecipes.find(
                x => x.fk_produit_intermediaire === ingredientProduct.id
              );
              if (ingredientRecipe) {
                if (
                  ingredientRecipe.data &&
                  ingredientRecipe.data.use_conversion_formula &&
                  recipe.data &&
                  recipe.data.use_conversion_formula
                ) {
                  quantity_required_recipe += mappers.recipeProdToInv(
                    (ingredient_quantity *
                      mappers.recipeInvToProd(
                        product.quantity + product.quantity_required_recipe,
                        recipe,
                        recipe.data
                      )) /
                      recipe.quantite_produite,
                    ingredientRecipe,
                    ingredientRecipe.data
                  );
                } else if (
                  ingredientRecipe.data &&
                  !ingredientRecipe.data.use_conversion_formula &&
                  recipe.data &&
                  recipe.data.use_conversion_formula
                ) {
                  quantity_required_recipe +=
                    (ingredient_quantity *
                      mappers.recipeInvToProd(
                        product.quantity + product.quantity_required_recipe,
                        recipe,
                        recipe.data
                      )) /
                    recipe.quantite_produite;
                } else if (
                  ingredientRecipe.data &&
                  ingredientRecipe.data.use_conversion_formula &&
                  recipe.data &&
                  !recipe.data.use_conversion_formula
                ) {
                  quantity_required_recipe += mappers.recipeProdToInv(
                    (ingredient_quantity *
                      (product.quantity + product.quantity_required_recipe)) /
                      recipe.quantite_produite,
                    ingredientRecipe,
                    ingredientRecipe.data
                  );
                } else {
                  quantity_required_recipe +=
                    (ingredient_quantity *
                      (product.quantity + product.quantity_required_recipe)) /
                    recipe.quantite_produite;
                }
              }
            } else {
              if (
                ingredientProduct.data &&
                ingredientProduct.data.use_conversion_formula &&
                recipe.data &&
                recipe.data.use_conversion_formula
              ) {
                quantity_required_recipe += mappers.productProdToInv(
                  (ingredient_quantity *
                    mappers.recipeInvToProd(
                      product.quantity + product.quantity_required_recipe,
                      recipe,
                      recipe.data
                    )) /
                    recipe.quantite_produite,
                  ingredientProduct.data
                );
              } else if (
                ingredientProduct.data &&
                ingredientProduct.data.use_conversion_formula
              ) {
                quantity_required_recipe += mappers.productProdToInv(
                  (ingredient_quantity *
                    (product.quantity + product.quantity_required_recipe)) /
                    recipe.quantite_produite,
                  ingredientProduct.data
                );
              } else {
                quantity_required_recipe +=
                  (ingredient_quantity *
                    (product.quantity + product.quantity_required_recipe)) /
                  recipe.quantite_produite;
              }
            }
          }
        }
      });
      item.quantity_required_recipe = round10(quantity_required_recipe, -6);
      item.quantity_required = round10(
        item.quantity + item.quantity_required_recipe,
        -6
      );
      return item.quantity_required_recipe;
    },
    getIngredientsValues(item) {
      const recipe = this.getRecipes.find(
        x => x.fk_produit_intermediaire === item.id
      );
      if (recipe) {
        const ingredients = this.$store.getters.getIngredientsByRecipe(
          recipe.id
        );
        return ingredients.map(x => {
          const ingredientProduct = this.getProducts.find(
            p => p.id === x.pk_recette_produit.id
          );
          if (ingredientProduct) {
            const item_quantity = recipe.data.use_conversion_formula
              ? mappers.recipeInvToProd(item.quantity, recipe, recipe.data)
              : item.quantity;
            const item_required_quantity = recipe.data.use_conversion_formula
              ? mappers.recipeInvToProd(
                  item.quantity_required_recipe,
                  recipe,
                  recipe.data
                )
              : item.quantity_required_recipe;

            let ingredient_quantity = x.quantite;
            if (ingredientProduct.data.use_conversion_formula) {
              if (
                !mappers.isCustomUnit(x.unite_mesure) &&
                !mappers.isCustomUnit(ingredientProduct.data.unite_mesure)
              ) {
                ingredient_quantity = this.$units(x.quantite)
                  .from(x.unite_mesure)
                  .to(ingredientProduct.data.unite_mesure);
              }
            } else {
              if (
                !mappers.isCustomUnit(x.unite_mesure) &&
                !mappers.isCustomUnit(
                  ingredientProduct.data.unite_mesure_inventory
                )
              ) {
                ingredient_quantity = this.$units(x.quantite)
                  .from(x.unite_mesure)
                  .to(ingredientProduct.data.unite_mesure_inventory);
              }
            }

            let quantity = round10(
              (ingredient_quantity * item_quantity) / recipe.quantite_produite,
              -6
            );
            let quantity_required_recipe = round10(
              (ingredient_quantity * item_required_quantity) /
                recipe.quantite_produite,
              -6
            );

            return {
              name: ingredientProduct.nom,
              quantity: quantity,
              quantity_required_recipe: quantity_required_recipe,
              quantity_required: round10(
                quantity + quantity_required_recipe,
                -6
              ),
              unit: ingredientProduct.data.use_conversion_formula
                ? ingredientProduct.data.unite_mesure
                : ingredientProduct.data.unite_mesure_inventory
            };
          } else {
            return {
              name: "Ingrédient inconnue"
            };
          }
        });
      }
    },
    getProductUnit(item) {
      const recipe = this.getRecipes.find(
        x => x.fk_produit_intermediaire === item.id
      );
      if (recipe) {
        if (recipe.data && recipe.data.use_conversion_formula) {
          return recipe.data.unite_inventory;
        } else {
          return recipe.unite_produite;
        }
      } else {
        return item.data && item.data.unite_mesure_inventory
          ? item.data.unite_mesure_inventory
          : item.data && item.data.unite_mesure
          ? item.data.unite_mesure
          : "";
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
